import React, { useEffect, useMemo, useState } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import { Card, CardBody, Input, Col } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { get } from '../../../../hook/request';
import { Btn, H3 } from '../../../../AbstractElements';

type GroupRow = {
  typeID: number;
  nomeType: string;
};

export default function PermissionsGroupsList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState<GroupRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState('');

  async function load() {
    setLoading(true);
    try {
      const res = await get<any>('/permissions/listGroup');
      const payload = (res as any)?.data ?? res;
      const list: GroupRow[] = Array.isArray(payload) ? payload : [];
      setRows(list);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  // 🔍 Filtra per nomeType
  const filteredRows = useMemo(() => {
    if (!filterText.trim()) return rows;
    const q = filterText.toLowerCase();
    return rows.filter((r) => r.nomeType?.toLowerCase().includes(q));
  }, [rows, filterText]);

  const columns: TableColumn<GroupRow>[] = useMemo(
    () => [
      {
        name: 'Nome',
        selector: (r) => r.nomeType ?? '',
        sortable: true,
        grow: 2,
      },
      {
        name: 'Azioni',
        width: '160px',
        button: true,
        ignoreRowClick: true,
        cell: (r) => (
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/admin/permissions/group/${encodeURIComponent(String(r.typeID))}`);
            }}
            title="Modifica"
          >
            Modifica
          </button>
        ),
      },
    ],
    [navigate]
  );

  return (
    <div className="page-body pt-4">
      <Col xxl={12} className="mb-lg-3">
        <Card>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <H3 className="mb-0">Gruppi permessi</H3>
              <Btn
                className="px-4"
                color="primary"
                type="button"
                onClick={() => navigate('/admin/permissions/group/new')}
              >
                NUOVO
              </Btn>
            </div>

            {/* 🔍 Barra di ricerca */}
            <div className="mb-3">
              <Input
                type="text"
                placeholder="Cerca per nome..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>

            <div className="table-responsive">
              <DataTable<GroupRow>
                columns={columns}
                data={filteredRows}
                progressPending={loading}
                striped
                pagination
                highlightOnHover
                dense
                noDataComponent="Nessun gruppo disponibile"
                paginationPerPage={50}
                customStyles={{
                  rows: { style: { minHeight: '34px', paddingTop: 6, paddingBottom: 6 } },
                  cells: { style: { padding: '6px 12px' } },
                  headCells: { style: { padding: '6px 12px', fontWeight: 600 } },
                }}
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </div>

  );
}
